/**
 * O PERCURSO DE DEMONSTRAÇÃO — doze questões, variantes fixas, ordem pensada.
 *
 * Existe por dois motivos práticos. O primeiro é de roteiro: cada questão prova uma
 * capacidade diferente do motor, na ordem em que se quer contá-la. O segundo é de
 * palco: o percurso padrão eram os 35 itens do banco, e clicar em "Começar" mandava
 * gerar os 35 de uma vez, com amostragem por rejeição, travando a tela no pior momento
 * possível.
 *
 * As seeds vêm com a versão do gerador junto. Se um item mudar de versão, o app avisa
 * que a variante aprovada ficou para trás em vez de mostrar outra coisa calado (ver
 * `fixadaDesatualizada`, em `config.ts`).
 *
 * Só dados: este módulo não importa nada em tempo de execução, para poder ser lido
 * tanto pela configuração quanto por quem monta a demonstração.
 */

import type { EntradaPercurso } from './config.ts';

export const DEMO: readonly Omit<EntradaPercurso, 'id'>[] = [
  // As cinco alternativas SÃO figuras geradas (estrutura E6).
  { templateId: 'h1-08-01-funcao-grafico', seed: 'demo0', versao: 5 },
  // Achar o erro no raciocínio alheio: contas certas, e a velocidade média tomada como a
  // média das velocidades.
  { templateId: 'k-erro-velocidade', seed: 'demo0', versao: 2 },
  // Figura gerada dos parâmetros, e cada distrator vindo de um erro com nome.
  { templateId: 'h3-30-05-media-agrupada', seed: 'demo0', versao: 5 },
  // Eixo cognitivo III: julgar uma manchete publicada, mexendo no começo do eixo.
  { templateId: 'h1-37-K01-eixo-truncado', seed: 'demo0', versao: 2 },
  // Eixo III em probabilidade: mexer na urna até a chance ser a pedida — e a chance
  // nunca aparece escrita.
  { templateId: 'h1-32-K01-urna', seed: 'demo0', versao: 1 },
  // Régua virtual: mede a figura, e não a tela.
  { templateId: 'h1-24-K01-escala-mapa', seed: 'demo0', versao: 1 },
  // Outro suporte: o gráfico de setores, lido pelo ângulo (entrou no lugar de "a maior
  // fatia não é a maioria", excluído a pedido do autor em 2026-09-30).
  { templateId: 'h1-34-K01-setor-angulo', seed: 'demo0', versao: 1 },
  // Um explorador que ensina a regra sem entregar a resposta, e marcação sobre a figura.
  { templateId: 'h2-15-K01-ladrilhar', seed: 'demo0', versao: 1 },
  // Responder agindo: levantar as colunas a partir da tabela.
  { templateId: 'h3-30-K02-montar-colunas', seed: 'demo0', versao: 1 },
  // A construção da álgebra: o mesmo cinto de ferramentas, o mesmo gravar da
  // trajetória e as mesmas estrelas — sobre uma equação, e não sobre uma figura.
  { templateId: 'h1-10-K01-balanca', seed: 'demo0', versao: 2 },
  // E então a construção geométrica, com régua e compasso: mesma máquina, outro objeto.
  { templateId: 'k-bissetriz', seed: 'demo0', versao: 2 },
  // Produzir uma expressão; correção por equivalência.
  { templateId: 'h1-12-K02-expressao', seed: 'demo0', versao: 1 },
];
